package ui.theme


import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.unit.sp


val displayLargeFont: TextStyle
    @Composable get() = TextStyle(fontFamily = Cinzel, fontWeight = FontWeight.Bold, fontSize = 72.sp)

val displayMediumFont: TextStyle
    @Composable get() = TextStyle(fontFamily = Cinzel, fontWeight = FontWeight.Bold, fontSize = 62.sp)


val displaySmallFont: TextStyle
    @Composable get() = TextStyle(fontFamily = Cinzel, fontWeight = FontWeight.Normal, fontSize = 56.sp)

val titleLargeFont: TextStyle
    @Composable get() = TextStyle(fontFamily = AlexBrush, fontSize = 52.sp)

val titleMediumFont: TextStyle
    @Composable get() = TextStyle(fontFamily = YesevaOne, fontSize = 28.sp)


val titleSmallFont: TextStyle
    @Composable get() = TextStyle(fontFamily = Domine, fontSize = 18.sp)

val bodyLarge: TextStyle
    @Composable get() = TextStyle(fontFamily = Raleway, fontSize = 18.sp)

val bodyMedium: TextStyle
    @Composable get() = TextStyle(fontFamily = Raleway)

val bodySmall: TextStyle
    @Composable get() = TextStyle(fontFamily = Raleway)

val default: TextStyle
    @Composable get() = TextStyle(fontFamily = NotoSans)

val Typography
    @Composable get() = Typography(
        displayLarge = displayLargeFont,
        displayMedium = displayMediumFont,
        displaySmall = displaySmallFont,
        titleLarge = titleLargeFont,
        titleMedium = titleMediumFont,
        titleSmall = titleSmallFont,
        bodyLarge = bodyLarge,
        bodyMedium = bodyMedium,
        bodySmall = bodySmall,
        labelLarge = default.copy(fontSize = 13.sp),
        labelMedium = default.copy(fontSize = 11.sp),
        labelSmall = default.copy(fontSize = 9.sp),
    )
